<template>
<div class="chapter">
<div class="inner_page">
<h2 class="Abb"><a id="pageviii">List of Figures</a></h2><a id="pageviii">
<p class="list_fig"><span class="list_fighang">1.</span> GS(R) Reports 1936–1939</p>
<p class="list_fig"><span class="list_fighang">2.</span> Summary list of MI(R) missions September 1939–October 1940</p>
<p class="list_fig"><span class="list_fighang">3.</span> War Establishment of MI(R), August 1940</p>
<p class="list_fig"><span class="list_fighang">4.</span> Extract from substitution codes in connection with the projected Norwegian campaign, February 1940</p>
<p class="list_fig"><span class="list_fighang">5.</span> Members of the Polish mission, August–October 1939</p>
<p class="list_fig"><span class="list_fighang">6.</span> Outline map of the towns featured in the 1940 Norwegian campaign</p>
<p class="list_fig"><span class="list_fighang">7.</span> Parent divisions and commanders of the Independent Companies</p>
<p class="list_fig"><span class="list_fighang">8.</span> Map showing the line of retreat from Mo i Rana to Bodo, Norway, in May 1940</p>
<p class="list_fig"><span class="list_fighang">9.</span> Outline map of the Middle East and African operations of MI(R)</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// List_of_Figures.vue?c07a14d2